import axios from "axios";
import { useCallback, useEffect, useState } from "react";
import { AlertTriangle, Check } from "lucide-react";
import { amt } from "../lib/invoice";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

const localTime = iso => new Date(iso).toLocaleString("tr-TR", { dateStyle: "short", timeStyle: "short" });

export default function ErpSyncAlert({ refreshKey, onAck }) {
  const [alerts, setAlerts] = useState([]);

  const load = useCallback(() => axios.get(`${API}/erp/alerts`).then(r => setAlerts(r.data.runs)), []);
  useEffect(() => { load().catch(() => {}); }, [load, refreshKey]);

  const ack = async runId => {
    await axios.post(`${API}/erp/alerts/${runId}/ack`);
    await load();
    onAck?.();
  };

  if (!alerts.length) return null;

  const changes = alerts.flatMap(run =>
    run.months.flatMap(m => m.changed.map(c => ({ ...c, run_id: run.id, month: m.month })))
  );
  const newOnly = alerts.filter(run => !run.months.some(m => m.changed.length));

  return (
    <section className="panel sync-alert" data-testid="erp-sync-alert">
      <div className="sync-alert-head">
        <AlertTriangle size={16}/>
        <div>
          <b>Satış aktarımı güncellendi</b>
          <small>
            {changes.length
              ? `${changes.length} günlük kaydın ciro, komisyon, satış adedi veya durumu güncellendi.`
              : `${alerts.reduce((sum, run) => sum + run.change_count, 0)} yeni gün-kalemi otomatik aktarıldı.`}
          </small>
        </div>
      </div>
      <div className="sync-alert-list">
        {changes.slice(0, 6).map(change => (
          <div key={`${change.run_id}-${change.erp_key}`} data-testid={`erp-change-${change.run_id}-${change.erp_key}`}>
            <span>{change.transaction_date} · {change.account} · {change.group}</span>
            <b>{change.status === "removed" ? "Pasifleştirildi · " : ""}
              {change.previous_gross_revenue != null ? `Ciro ${amt(change.previous_gross_revenue, change.currency)} → ${amt(change.gross_revenue, change.currency)}`
                : `${amt(change.previous_amount, change.currency)} → ${amt(change.amount, change.currency)}`}
              {change.previous_sale_count != null && <small className="sub-line">Satış: {change.previous_sale_count} → {change.sale_count}</small>}
            </b>
          </div>
        ))}
        {newOnly.map(run => (
          <div key={run.id} data-testid={`erp-run-note-${run.id}`}>
            <span>{localTime(run.started_at)} · {run.trigger === "auto" ? "otomatik" : "elle"} senkron</span>
            <b>{run.ok ? `${run.created_count} yeni kayıt` : `Hata: ${run.error}`}</b>
          </div>
        ))}
      </div>
      <div className="sync-alert-actions">
        {alerts.map(run => (
          <button key={run.id} className="outline-btn small" data-testid={`erp-ack-${run.id}`} onClick={() => ack(run.id)}>
            <Check size={14}/> Gördüm ({localTime(run.started_at)})
          </button>
        ))}
      </div>
    </section>
  );
}
